import type { VersionOptimizeStatus } from "@/domain/Version";
import {
  CheckmarkCircle20Regular,
  Circle20Regular,
  DismissCircle20Regular,
  PauseCircle20Regular,
  SparkleCircle20Regular,
} from "@fluentui/react-icons";
import type React from "react";

type IconComponent = React.FC<React.HTMLAttributes<SVGElement>>;

const versionOptimizeStatusIconList: {
  [key in Exclude<VersionOptimizeStatus, null> | "null"]: {
    Icon: IconComponent;
    color?: string;
  };
} = {
  queued: { Icon: PauseCircle20Regular },
  in_progress_evaluation: {
    Icon: SparkleCircle20Regular,
    color: "var(--figma-color-theme-primary)",
  },
  success_evaluation: {
    Icon: CheckmarkCircle20Regular,
    color: "var(--figma-color-success-green)",
  },
  queued_optimization: { Icon: PauseCircle20Regular },
  in_progress_optimization: {
    Icon: SparkleCircle20Regular,
    color: "var(--figma-color-theme-primary)",
  },
  success_optimization: {
    Icon: CheckmarkCircle20Regular,
    color: "var(--figma-color-success-green)",
  },
  failure_in_optimization: { Icon: DismissCircle20Regular, color: "red" },
  failure_input_evaluation: { Icon: DismissCircle20Regular, color: "red" },
  failure_exception: { Icon: DismissCircle20Regular, color: "red" },
  canceled_evaluation: { Icon: Circle20Regular },
  canceled_optimization: { Icon: Circle20Regular },
  null: { Icon: Circle20Regular },
};

export const getVersionOptimizeStatusIcon = (
  status: VersionOptimizeStatus | null
) => {
  return (
    versionOptimizeStatusIconList[status ?? "null"] ??
    versionOptimizeStatusIconList["null"]
  );
};
